import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var footer = {
  name: "1nt4q7x",
  styles: "position:relative;margin:40px 0 0;"
};
export var map = /*#__PURE__*/css("height:279px;", media('>=tablet'), "{height:348px;}.allhomes-map{height:100%;}");